import styled, { createGlobalStyle } from 'styled-components';

// import Bg from './Background/_img_bg.jpg';
import Mobile from './Background/phone.png';

import _Background from './Background/background.png';
import _Foreground from './Background/foreground.png';
import _Earth from './Background/earth.png';

export const GlobalStyle = createGlobalStyle`
  html {
    background: black;
    background-image: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.4) 25%,
        rgba(0, 0, 0, 0.5) 50%,
        rgba(0, 0, 0, 0.4) 75%,
        rgba(0, 0, 0, 0) 100%
      ),
      url(${Mobile});
    background-size: 100%;
    background-position: top;
    background-repeat: no-repeat;
    scroll-behavior: smooth;
  }

  html, body {
    margin: 0;
    padding: 0;
  }

  body {
    overflow-x: hidden;
  }

  .react-toast-notifications__container{
    z-index: 10000 !important; // This is the only time I will do it. Not recommended.
  }

  .react-toast-notifications__toast {
    font-family: 'Lato';
  }

  table td {
    white-space: pre-wrap !important;
  }

  a {
    color: #baace8;
    text-decoration: none;

    &::before {
      content: ' ';
    }

    &::after {
      content: ' ';
    }
  }

  .content-container {
    background: rgba(0, 0, 0, 0.75);
    border-radius: 0px;

    @media only screen and (min-width: 768px) {
      border-radius: 15px;
      margin: 2rem auto;
    }
  }
`;

export const Earth = styled.div`
  background-image: url(${_Earth});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  max-height: 912px;
  max-width: 912px;

  height: 130vw;
  width: 130vw;
`;

export const AppWrapper = styled.div`
  min-height: 100vh;
  position: relative;
`;

export const BgWrapper = styled.div`
  display: none;
  height: 100%;
  z-index: -1;
  position: absolute;

  .earth-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;

    & .parallax-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding-top: 10vh;
    }
  }

  @media only screen and (min-width: 1200px) {
    display: block;
  }
`;

export const Background = styled.div`
  background-image: url(${_Background});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  position: fixed;

  height: 100vh;
  width: 100vw;
`;

export const Foreground = styled.div`
  background-image: url(${_Foreground});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  position: fixed;

  min-height: 100%;
  width: 100vw;
`;

export const Overlay = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 25%,
    rgba(0, 0, 0, 0.5) 50%,
    rgba(0, 0, 0, 0.4) 75%,
    rgba(0, 0, 0, 0) 100%
  );
`;
